import { useState, useEffect } from 'react';

const useMobileNav = () => {
    const [bottomNavExpanded, setBottomNavExpanded] = useState(false);
    const [mobileFilters, setMobileFilters] = useState(false);
    const [mobileStats, setMobileStats] = useState(false);

    const toggleMenu = (menuType) => {
        if (menuType === 'filters') {
            setMobileFilters(!mobileFilters);
            setMobileStats(false);
        } else if (menuType === 'stats') {
            setMobileStats(!mobileStats);
            setMobileFilters(false);
        }
    };

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setMobileFilters(true);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return { bottomNavExpanded, setBottomNavExpanded, mobileFilters, mobileStats, toggleMenu };
};

export default useMobileNav;
